// Shared bordered-grid table used across the UT Bills module so every list of
// bills/payments matches the "UT-Bills Wallet Statements" table style: a blue
// header, gridded cells, tiny text, and table-fixed + colgroup widths so it
// fits on a phone and wraps instead of scrolling sideways.
//
// columns: [{ label, width, align?: 'left'|'right'|'center', render: (row) => node }]
// summaryRow (optional): array of nodes, one per column, rendered as a highlighted
// row directly under the header (e.g. a Totals row). Kept in its own <tbody> so it
// doesn't shift the odd/even striping of the data rows.
function StatementTable({ columns, rows, rowKey, emptyText = "Nothing here yet.", summaryRow }) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return <p className="px-4 py-8 text-center text-sm text-slate-500">{emptyText}</p>
  }

  const headAlign = (align) => (align === "right" ? "text-right" : align === "left" ? "text-left" : "text-center")
  const cellAlign = (align) => (align === "right" ? "text-right" : align === "center" ? "text-center" : "text-left")

  return (
    <table className="w-full table-fixed border border-emerald-200 text-[9px] leading-[1.05] sm:text-xs">
      <colgroup>
        {columns.map((column, index) => (
          <col key={index} style={column.width ? { width: column.width } : undefined} />
        ))}
      </colgroup>
      <thead className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white">
        <tr>
          {columns.map((column, index) => (
            <th
              key={index}
              className={`border border-emerald-500/40 px-0.5 py-1 font-semibold sm:px-2 sm:py-2 ${headAlign(column.align)}`}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      {Array.isArray(summaryRow) && summaryRow.length > 0 && (
        <tbody>
          <tr className="bg-emerald-100/70 font-semibold text-slate-900">
            {columns.map((column, index) => (
              <td
                key={index}
                className={`border border-emerald-200 px-0.5 py-1.5 align-top break-words sm:px-2 sm:py-2 ${cellAlign(column.align)}`}
                style={{ wordBreak: "break-word" }}
              >
                {summaryRow[index]}
              </td>
            ))}
          </tr>
        </tbody>
      )}
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowKey ? rowKey(row, rowIndex) : rowIndex} className="odd:bg-white even:bg-emerald-50/40">
            {columns.map((column, index) => (
              <td
                key={index}
                className={`border border-emerald-100 px-0.5 py-1 align-top break-words sm:px-2 sm:py-2 ${cellAlign(column.align)}`}
                style={{ wordBreak: "break-word" }}
              >
                {column.render(row)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default StatementTable
